import ko from "knockout";
import manifestManager from "flow/utils/manifestManager";
import config from "flow/config";
import viewCache from "flow/utils/viewCache";
import { CloseCallback } from "flow/api/types";
import bind from "bind-decorator";
import viewHtml from "./InformationDialog.html";

export interface IInformationDialogViewContext {
    title: string;
    text: string;
}

// I create my own manifest
manifestManager.addManifests(config.moduleId, [
    {
        id: config.componentIds.information,
        isDialog: true,
        namespace: "default",
        reuseInstance: false,
        useFormValidation: false,
        viewModelId: "flow/viewModels/InformationDialog",
        viewUrl: "virtual/InformationDialog"
    }
]);

viewCache.inject("virtual/InformationDialog", viewHtml);

export default class InformationDialog {
    closeFunc: CloseCallback;
    componentTitle = ko.observable();
    text = ko.observable();
    focusObservable = ko.observable();

    activate(viewContext: IInformationDialogViewContext, closeCallback: CloseCallback) {
        this.closeFunc = closeCallback;
        this.componentTitle(viewContext.title);
        this.text(viewContext.text);

        this.focusObservable(true);
    }

    @bind
    close() {
        this.closeFunc(false);
    }

    commands() {
        return [{ text: "OK", click: this.close, focusObs: this.focusObservable }];
    }

    getDimensions(maxWidth: number, _maxHeight: number) {
        return {
            width: Math.min(maxWidth - 24, 600),
            height: "auto"
        };
    }
}
